import { render, staticRenderFns } from "./Paylook.vue?vue&type=template&id=308854c9&scoped=true"
import script from "./Paylook.vue?vue&type=script&lang=js"
export * from "./Paylook.vue?vue&type=script&lang=js"
import style0 from "./Paylook.vue?vue&type=style&index=0&id=308854c9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308854c9",
  null
  
)

export default component.exports